import { createAction } from '@reduxjs/toolkit';
import { ofType } from 'redux-observable';
import { exhaustMap } from 'rxjs/operators';

import { addToastAction as addToast } from '@perpay-web/components/base/ToastProvider/useToastContext';
import { analyticsSelfServiceEmailUpdateSuccess } from '@perpay-web/fintech/actions/analytics/userInfo';
import {
    updateUserInfoContext,
    updateUserInfoContextSuccess as updateUserInfoContextSuccessAction,
} from '@perpay-web/fintech/actions/entities/userInfo';
import { routeToLocation } from '@perpay-web/fintech/actions/router';
import {
    editEmailSetSteps as editEmailSetStepsAction,
    VERIFY_MFA,
} from '@perpay-web/fintech/components/screens/EditEmail/useEditEmailContext';
import { paths } from '@perpay-web/fintech/props/appPaths';
import { dispatchObservable } from '@perpay-web/observable/dispatchObservable';

export const selfServiceUpdateEmail = createAction('SELF_SERVICE_UPDATE_EMAIL');
const selfServiceUpdateEmailSuccess = createAction(
    'SELF_SERVICE_UPDATE_EMAIL_SUCCESS',
);

export const submitEmail = (action$, state$) =>
    action$.pipe(
        ofType(selfServiceUpdateEmail().type),
        exhaustMap((action) =>
            dispatchObservable({
                action$,
                state$,
                initialDispatch: [updateUserInfoContext(action.payload)],
                waitFor: [updateUserInfoContextSuccessAction().type],
                waitForDispatch: (state, results) => [
                    selfServiceUpdateEmailSuccess(results.response),
                    analyticsSelfServiceEmailUpdateSuccess(action.payload),
                    editEmailSetStepsAction(VERIFY_MFA),
                    routeToLocation(paths.profile.path),
                    addToast({ message: 'Email updated' }),
                ],
            }),
        ),
    );
